import React, { useState } from 'react';
import DashboardTable from './DashboardTable';
import AdminLeaves from './AdminLeaves';
import AdminReports from './AdminReports';
import DashboardCharts from './DashboardCharts';

const AdminDashboard = ({ employees, attendanceRecords }) => {
  const [activeTab, setActiveTab] = useState('resumen');



  return (
    <div className="space-y-8 max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-2 border-b border-slate-900">
        <div>
          <h1 className="text-3xl font-extrabold text-slate-100">Panel Administrativo</h1>
          <p className="text-sm text-slate-400 mt-1">Supervise la asistencia y gestione los recursos humanos.</p>
        </div>
        
        {/* TABS */}
        <div className="flex bg-slate-900 p-1 rounded-xl">
          <button 
            onClick={() => setActiveTab('resumen')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === 'resumen' ? 'bg-slate-800 text-cyan-400 shadow-sm' : 'text-slate-400 hover:text-slate-200'}`}
          >
            Resumen
          </button>
          <button 
            onClick={() => setActiveTab('registros')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === 'registros' ? 'bg-slate-800 text-cyan-400 shadow-sm' : 'text-slate-400 hover:text-slate-200'}`}
          >
            Registros
          </button>
          <button 
            onClick={() => setActiveTab('permisos')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === 'permisos' ? 'bg-slate-800 text-cyan-400 shadow-sm' : 'text-slate-400 hover:text-slate-200'}`}
          >
            Permisos
          </button>
          <button 
            onClick={() => setActiveTab('reportes')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === 'reportes' ? 'bg-slate-800 text-cyan-400 shadow-sm' : 'text-slate-400 hover:text-slate-200'}`}
          >
            Exportar
          </button>
        </div>
      </div>
      
      {activeTab === 'resumen' && (
        <DashboardCharts employees={employees} attendanceRecords={attendanceRecords} />
      )}

      {activeTab === 'registros' && (
        <DashboardTable attendanceRecords={attendanceRecords} />
      )}

      {activeTab === 'permisos' && (
        <AdminLeaves employees={employees} />
      )}

      {activeTab === 'reportes' && (
        <AdminReports attendanceRecords={attendanceRecords} employees={employees} />
      )}

    </div>
  );
};

export default AdminDashboard;